// extracted by mini-css-extract-plugin
module.exports = {"ratingsBar":"Reviews_ratingsBar__6NMyo","companyRatingsBar":"Reviews_companyRatingsBar__pq353"};